module.exports = __webpack_public_path__ + "img/farming_45.ca9a186f.png";